import { render, staticRenderFns } from "./VasionConfidenceChip.vue?vue&type=template&id=78cd130a&scoped=true&"
import script from "./VasionConfidenceChip.vue?vue&type=script&lang=js&"
export * from "./VasionConfidenceChip.vue?vue&type=script&lang=js&"
import style0 from "./VasionConfidenceChip.vue?vue&type=style&index=0&id=78cd130a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cd130a",
  null
  
)

export default component.exports